(function () {
  'use strict';

  window.__nestMrcCartFooterDisplay20260708 = 'v8-native-recycling-fee-row';

  var feeVariantId = 39273096544337;
  var feeProductId = 6543483142225;
  var timer = null;
  var running = false;
  var pending = false;
  var rootSelector = '.cart-modal,#CartDrawer,.cart-drawer,.drawer--cart,.ajax-cart,.ajaxcart,[data-cart-drawer],[data-cart-container]';
  var rowSelector = '.cart-item,[data-cart-item],.cart__row,.cart__item,.ajaxcart__product,.ajax-cart__item';
  var controlsSelector = 'button,a,input,select,textarea,[role="button"],[data-cart-remove],[href*="/cart/change"],.cart__qty,.quantity,.js-qty';

  function clean(value) {
    return String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function isVisible(element) {
    if (!element || !document.documentElement.contains(element)) return false;
    if (element.hasAttribute('hidden') || element.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && rect.width > 0 && rect.height > 0;
  }

  function propsOf(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function itemText(item) {
    return [
      item && item.product_title,
      item && item.title,
      item && item.handle,
      item && item.url,
      item && item.product_type
    ].join(' ').toLowerCase();
  }

  function isMrcFeeItem(item) {
    var props = propsOf(item);
    var text = itemText(item);
    return Number(item && item.variant_id) === feeVariantId ||
      Number(item && item.product_id) === feeProductId ||
      String(props.type || '').toLowerCase() === 'fee' ||
      /mrc recycling fee|mattress recycling fee/i.test(text);
  }

  function mrcFeeCents(cart) {
    return (cart && cart.items || []).reduce(function (sum, item) {
      return sum + (isMrcFeeItem(item) ? Number(item.final_line_price || 0) : 0);
    }, 0);
  }

  function formatMoney(cents) {
    var dollars = (Math.max(0, Math.round(cents || 0)) / 100).toFixed(2);
    var parts = dollars.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function visibleCartRoots() {
    var roots = Array.prototype.slice.call(document.querySelectorAll(rootSelector)).filter(isVisible);
    return roots.filter(function (root) {
      return !roots.some(function (other) {
        return other !== root && other.contains(root) && isVisible(other);
      });
    });
  }

  function rowLooksLikeMrc(row) {
    if (!row) return false;
    var text = clean(row.textContent);
    var variant = row.getAttribute('data-variant-id') || row.getAttribute('data-cart-item-variant-id') || '';
    var product = row.getAttribute('data-product-id') || row.getAttribute('data-cart-item-product-id') || '';
    return variant === String(feeVariantId) ||
      product === String(feeProductId) ||
      /MRC Recycling Fee|Mattress Recycling Fee/i.test(text);
  }

  function lockMrcControls(row) {
    Array.prototype.slice.call(row.querySelectorAll(controlsSelector)).forEach(function (control) {
      control.setAttribute('tabindex', '-1');
      control.setAttribute('aria-hidden', 'true');
      control.style.setProperty('display', 'none', 'important');
      if ('disabled' in control) control.disabled = true;
    });
  }

  function clearPreviousMrcMarks(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-nest-mrc-fee-row="true"]')).forEach(function (row) {
      row.removeAttribute('data-nest-mrc-fee-row');
      row.removeAttribute('aria-hidden');
      if (row.style && row.style.getPropertyValue('display') === 'none') row.style.removeProperty('display');
    });
  }

  function hideMrcRows(root) {
    clearPreviousMrcMarks(root);

    var rows = Array.prototype.slice.call(root.querySelectorAll(rowSelector)).filter(function (row) {
      return !Array.prototype.slice.call(row.querySelectorAll(rowSelector)).some(function (child) {
        return child !== row && rowLooksLikeMrc(child);
      });
    });

    rows.forEach(function (row) {
      if (!rowLooksLikeMrc(row)) return;
      row.setAttribute('data-nest-mrc-fee-row', 'true');
      row.setAttribute('aria-hidden', 'true');
      row.style.setProperty('display', 'none', 'important');
      lockMrcControls(row);
    });
  }

  function directText(node) {
    return clean(Array.prototype.slice.call(node.childNodes || []).filter(function (child) {
      return child.nodeType === Node.TEXT_NODE;
    }).map(function (child) {
      return child.nodeValue || '';
    }).join(' '));
  }

  function leafNodes(root) {
    return Array.prototype.slice.call(root.querySelectorAll('*')).filter(function (node) {
      return node.children.length === 0;
    });
  }

  function findSummaryLabel(root, pattern) {
    return Array.prototype.slice.call(root.querySelectorAll('*')).filter(function (node) {
      var direct = directText(node);
      var full = clean(node.textContent);
      return pattern.test(direct) || (full.length < 80 && pattern.test(full));
    }).filter(function (node) {
      return !Array.prototype.slice.call(node.children || []).some(function (child) {
        return pattern.test(clean(child.textContent));
      });
    })[0] || null;
  }

  function summaryRowForLabel(label) {
    var node = label ? label.parentElement : null;
    for (var depth = 0; node && depth < 8; depth += 1, node = node.parentElement) {
      var text = clean(node.textContent);
      if (/MRC Fee|Taxes|Total/i.test(text) && text.length < 220 && (/\$[0-9,]+(?:\.\d{2})?/.test(text) || depth > 0)) return node;
    }
    return label.parentElement || label;
  }

  function amountNode(row) {
    var leaves = leafNodes(row).filter(function (node) {
      return /^\$[0-9,]+(?:\.\d{2})?$|^TBD$/i.test(clean(node.textContent));
    });
    return leaves.length ? leaves[leaves.length - 1] : null;
  }

  function setSummaryAmount(row, cents) {
    var amount = amountNode(row);
    if (amount) {
      amount.textContent = formatMoney(cents);
      amount.setAttribute('data-nest-mrc-fee-source', 'cart-line-total');
    } else {
      replaceLastMoneyText(row, cents);
    }
    row.removeAttribute('hidden');
    row.removeAttribute('aria-hidden');
    row.style.removeProperty('display');
    row.setAttribute('data-nest-mrc-fee-summary', 'true');
    row.setAttribute('data-nest-mrc-fee-cents', String(Math.max(0, Math.round(cents || 0))));
  }

  function replaceLastMoneyText(container, cents) {
    if (!container || !document.createTreeWalker) return false;
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return /\$[0-9,]+(?:\.\d{2})?/.test(node.nodeValue || '') ?
          NodeFilter.FILTER_ACCEPT :
          NodeFilter.FILTER_REJECT;
      }
    });
    var node;
    var last = null;
    while ((node = walker.nextNode())) last = node;
    if (!last) return false;
    last.nodeValue = last.nodeValue.replace(/\$[0-9,]+(?:\.\d{2})?(?!.*\$[0-9,]+(?:\.\d{2})?)/, formatMoney(cents));
    return true;
  }

  function setSiblingSummaryAmount(label, cents) {
    var node = label;
    for (var depth = 0; node && depth < 5; depth += 1, node = node.parentElement) {
      var next = node.nextElementSibling;
      var prev = node.previousElementSibling;
      if (next && /^\$[0-9,]+(?:\.\d{2})?$|^TBD$/i.test(clean(next.textContent))) {
        next.textContent = formatMoney(cents);
        next.setAttribute('data-nest-mrc-fee-source', 'cart-line-total');
        return true;
      }
      if (prev && /^\$[0-9,]+(?:\.\d{2})?$|^TBD$/i.test(clean(prev.textContent))) {
        prev.textContent = formatMoney(cents);
        prev.setAttribute('data-nest-mrc-fee-source', 'cart-line-total');
        return true;
      }
    }
    return false;
  }

  function forceSummaryAmount(root, cents) {
    var labels = Array.prototype.slice.call(root.querySelectorAll('*')).filter(function (node) {
      return /^MRC Fee:?$/i.test(clean(node.textContent)) && node.children.length === 0;
    });

    labels.forEach(function (label) {
      var row = summaryRowForLabel(label);
      setSummaryAmount(row, cents);
      setSiblingSummaryAmount(label, cents);
    });
  }

  function clearGeneratedSummaryRows(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-nest-mrc-fee-summary="true"], .nest-mrc-fee-summary-row')).forEach(function (row) {
      if (row.matches && row.matches('.cart-subtotal.recycling-fee')) return;
      if (row && row.parentNode) row.parentNode.removeChild(row);
    });
  }

  function nativeMrcSummaryRow(root) {
    var row = root.querySelector('.cart-subtotal.recycling-fee');
    if (row) return row;

    var title = Array.prototype.slice.call(root.querySelectorAll('.cart-subtotal__title')).filter(function (node) {
      return clean(node.textContent).replace(/\s+/g, '').toLowerCase().indexOf('mrcfee') > -1;
    })[0];

    return title ? title.closest('.cart-subtotal, .recycling-fee, [class*="subtotal" i]') : null;
  }

  function updateNativeMrcSummary(row, cents) {
    if (!row) return false;
    var amount = row.querySelector('.cart-subtotal__price b, .cart-subtotal__price, [class*="price" i] b, [class*="price" i]');
    if (!amount) return updateMoneyText(row, cents);
    amount.textContent = formatMoney(cents);
    amount.setAttribute('data-nest-mrc-fee-source', 'cart-line-total');
    row.setAttribute('data-nest-mrc-fee-cents', String(Math.max(0, Math.round(cents || 0))));
    row.removeAttribute('data-nest-mrc-fee-summary');
    row.removeAttribute('hidden');
    row.removeAttribute('aria-hidden');
    row.style.removeProperty('display');
    return true;
  }

  function rowTextLooksLikeMrcFee(text) {
    var compact = clean(text).replace(/\s+/g, '').toLowerCase();
    return compact.indexOf('mrcfee') > -1 && /\$[0-9,]+(?:\.\d{2})?/.test(text);
  }

  function visibleMrcSummaryRow(root) {
    var nodes = Array.prototype.slice.call(root.querySelectorAll('*')).filter(function (node) {
      if (node.getAttribute('data-nest-mrc-fee-row') === 'true') return false;
      if (node.getAttribute('data-nest-mrc-fee-summary') === 'true') return false;
      var text = clean(node.textContent);
      if (!text || text.length > 240 || !rowTextLooksLikeMrcFee(text)) return false;
      return !node.closest('[data-nest-mrc-fee-row="true"]') && !node.closest('.nest-mrc-fee-summary-row');
    });

    nodes = nodes.filter(function (node) {
      return !nodes.some(function (other) {
        return other !== node && node.contains(other) && rowTextLooksLikeMrcFee(clean(other.textContent));
      });
    });

    return nodes[0] || null;
  }

  function visibleMrcSummaryLabel(root) {
    var labels = Array.prototype.slice.call(root.querySelectorAll('*')).filter(function (node) {
      if (node.getAttribute('data-nest-mrc-fee-row') === 'true') return false;
      if (node.getAttribute('data-nest-mrc-fee-summary') === 'true') return false;
      if (node.closest('[data-nest-mrc-fee-row="true"], .nest-mrc-fee-summary-row')) return false;
      var compact = clean(node.textContent).replace(/\s+/g, '').toLowerCase();
      return compact.indexOf('mrcfee') > -1 && compact.length < 40;
    });

    labels = labels.filter(function (node) {
      return !labels.some(function (other) {
        return other !== node && node.contains(other);
      });
    });

    return labels[0] || null;
  }

  function updateMoneyText(container, cents) {
    if (!container || !document.createTreeWalker) return false;
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return /\$[0-9,]+(?:\.\d{2})?/.test(node.nodeValue || '') ?
          NodeFilter.FILTER_ACCEPT :
          NodeFilter.FILTER_REJECT;
      }
    });
    var node;
    var last = null;
    while ((node = walker.nextNode())) last = node;
    if (!last) return false;
    last.nodeValue = last.nodeValue.replace(/\$[0-9,]+(?:\.\d{2})?(?!.*\$[0-9,]+(?:\.\d{2})?)/, formatMoney(cents));
    container.setAttribute('data-nest-mrc-fee-cents', String(Math.max(0, Math.round(cents || 0))));
    container.setAttribute('data-nest-mrc-fee-source', 'cart-line-total');
    container.removeAttribute('hidden');
    container.removeAttribute('aria-hidden');
    container.style.removeProperty('display');
    return true;
  }

  function updateMrcSummary(root, cents) {
    clearGeneratedSummaryRows(root);
    if (updateNativeMrcSummary(nativeMrcSummaryRow(root), cents)) return;
    var existing = visibleMrcSummaryRow(root);
    var label = existing ? null : visibleMrcSummaryLabel(root);
    if (!existing && label) existing = summaryRowForLabel(label);
    if (existing && cents > 0 && updateMoneyText(existing, cents)) return;
    if (label && cents > 0 && setSiblingSummaryAmount(label, cents)) return;
    if (existing && cents <= 0) {
      existing.style.setProperty('display', 'none', 'important');
      return;
    }
  }

  function apply(cart) {
    var cents = mrcFeeCents(cart);
    window.__nestMrcCartFooterLastFeeCents = cents;
    window.__nestMrcCartFooterLastFeeText = formatMoney(cents);
    visibleCartRoots().forEach(function (root) {
      hideMrcRows(root);
      updateMrcSummary(root, cents);
    });
  }

  function run() {
    if (!window.fetch) return;
    if (running) {
      pending = true;
      return;
    }
    running = true;
    pending = false;

    window.fetch('/cart.js?mrc_raw=1', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then(function (response) { return response.json(); })
      .then(apply)
      .catch(function () {})
      .finally(function () {
        running = false;
        if (pending) schedule(80);
      });
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, typeof delay === 'number' ? delay : 180);
  }

  function installStyle() {
    if (document.getElementById('nest-mrc-cart-footer-display-20260708')) return;
    var style = document.createElement('style');
    style.id = 'nest-mrc-cart-footer-display-20260708';
    style.textContent = [
      '[data-nest-mrc-fee-row="true"] { display: none !important; }',
      '[data-nest-mrc-fee-row="true"] button,',
      '[data-nest-mrc-fee-row="true"] a,',
      '[data-nest-mrc-fee-row="true"] input,',
      '[data-nest-mrc-fee-row="true"] select,',
      '[data-nest-mrc-fee-row="true"] textarea,',
      '[data-nest-mrc-fee-row="true"] [role="button"] { display: none !important; pointer-events: none !important; }',
      '.cart-modal .cart-item:has(a[href*="mrc-recycling-fee" i]),',
      '.cart-modal .cart-item:has(a[href*="mattress-recycling-fee" i]),',
      '.cart-modal .cart-item:has(img[alt*="MRC Recycling Fee" i]),',
      '.cart-modal .cart-item:has(img[alt*="Mattress Recycling Fee" i]),',
      '.cart-modal [data-cart-item]:has(a[href*="mrc-recycling-fee" i]),',
      '.cart-modal [data-cart-item]:has(a[href*="mattress-recycling-fee" i]) { display: none !important; }',
      '.nest-mrc-fee-summary-row { display: none !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function bind() {
    installStyle();
    schedule(0);
    [120, 400, 900, 1600, 2800].forEach(function (delay) { window.setTimeout(run, delay); });
    document.addEventListener('click', function () { schedule(220); }, true);
    document.addEventListener('change', function () { schedule(220); }, true);
    document.addEventListener('refreshAjaxCart', function () { schedule(220); }, true);
    document.addEventListener('cart:refresh', function () { schedule(220); }, true);
    document.addEventListener('refreshCart', function () { schedule(220); }, true);

    if (window.MutationObserver) {
      new MutationObserver(function () { schedule(280); }).observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    window.setInterval(run, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
